/*
 * Created by ORYX Movement Solutions © 2022
 * ==================================================================
 *
 * Loginpage.
 */

import { IonCol, IonContent, IonGrid, IonImg, IonPage, IonRow } from '@ionic/react';
import login_bg from '../../assets/login/login_bg.png';
import login_image from '../../assets/login/login_image.png';
import { ErrorToast } from '../../components/ErrorToast';
import { useAuthContext } from '../../contexts/authContext';
import { ResetPasswordForm } from './forms/ResetPasswordForm';
import './index.css';

export const ResetPasswordPage: React.FC = () => {
  const { state, clearError } = useAuthContext();

  return (
    <IonPage>
      <IonContent className='login ion-no-padding' id='main'>
        <IonGrid fixed className='ion-no-padding ion-no-margin'>
          <IonRow>
            <IonCol size='6' className='login-col_left ion-hide-md-down'>
              <IonImg src={login_bg} className='intro_bg'></IonImg>
              <IonImg src={login_image} className='intro_image'></IonImg>
            </IonCol>

            <IonCol size-md='6' size-sm='12' className='login-col'>
              <ResetPasswordForm />
            </IonCol>
          </IonRow>
        </IonGrid>
      </IonContent>

      <ErrorToast message={state.error} clearError={clearError} />
    </IonPage>
  );
};
